import { useMemo } from "react";
import { matchPath } from "react-router-dom";
import { useZustandLocation } from "@faire/retailer/app/_lib/routing/useZustandLocation";
import { useHasOnlyDismissedHighPriorityNotifications } from "@faire/retailer/components/Header/HeaderNotifications/__internal__/NotificationDropdown/hooks/useHasOnlyDismissedHighPriorityNotifications";
import { useNotifications } from "@faire/retailer/components/Header/HeaderNotifications/hooks/useNotifications";
import { home } from "@faire/retailer/paths";
export var useShouldPerformHighPriorityAction = function() {
    var _notification_message;
    var hasOnlyDismissedHighPriorityNotifications = useHasOnlyDismissedHighPriorityNotifications();
    var pathname = useZustandLocation(function(state) {
        return state.pathname;
    }).pathname;
    var isOnHome = matchPath(pathname, {
        path: home(),
        exact: true
    });
    var notifications = useNotifications().notifications;
    var notification = useMemo(function() {
        return notifications === null || notifications === void 0 ? void 0 : notifications.find(function(notification) {
            return notification.priority === "HIGH";
        });
    }, [
        notifications
    ]);
    var _notification_message_path;
    var notificationPath = (_notification_message_path = notification === null || notification === void 0 ? void 0 : (_notification_message = notification.message) === null || _notification_message === void 0 ? void 0 : _notification_message.path) !== null && _notification_message_path !== void 0 ? _notification_message_path : "";
    return (!pathname.includes(notificationPath) || !!isOnHome) && hasOnlyDismissedHighPriorityNotifications;
};
